









































































































































































































import { Component, Vue } from 'vue-property-decorator';
import AuthService from '@/services/auth';
import UserService from '@/services/user';
import Uploader from '@/components/Uploader.vue';
import User from '@/entities/User';
import IconOrLoader from '@/components/svg/IconOrLoader.vue';

@Component({
    components: {
        Uploader,
        IconOrLoader,
    },
})
export default class EditProfile extends Vue {
    authService = new AuthService();

    userService = new UserService();

    loading = false;

    uploading = false;

    languages = [
        {
            code: 'en',
            name: 'English',
        },
        {
            code: 'nl',
            name: 'Nederlands',
        },
        {
            code: 'fr',
            name: 'Français',
        },
    ];

    get user(): User {
        return this.authService.currentUser;
    }

    set user(user: User) {
        this.authService.currentUser = user;
    }

    get userAny(): any {
        return this.user;
    }

    get showIncomplete(): boolean {
        return !!this.$route.query.incompleteIndicator
            && this.requiredFields.some((field: any) => !field.completed);
    }

    get requiredFields(): object[] {
        const fields = [
            'firstname',
            'lastname',
            'email',
            'phone',
            'vat',
            'address',
            'passportScan',
        ];

        return fields.map((field: string) => {
            const object = {
                name: field,
                completed: !!this.userAny[field],
            };
            return object;
        });
    }

    save() {
        this.loading = true;
        this.userService
            .update(this.user)
            .then((user) => {
                this.user = user;
                this.$nextTick(() => this.$router.replace('/user/profile'));
            })
            .finally(() => {
                this.loading = false;
            });
    }

    selectProfilePicture() {
        document.getElementById('setProfilePicture').click();
    }

    selectPassportScan() {
        document.getElementById('setPassportScan').click();
    }

    setProfilePicture(url: string) {
        this.authService.currentUser.profileImage = url;
    }

    setPassportScan(url: string) {
        this.uploading = false;
        if (!this.authService.currentUser.passportScan) {
            this.authService.currentUser.passportScan = url;
        } else {
            this.authService.currentUser.passportScanVerso = url;
        }
    }
}
